import React from "react";
import { BookHeart, Clock, Users, X, Leaf } from "lucide-react";

export default function MyRasaBox({ savedRecipes, onSelect, onUnsave }) {
  if (!savedRecipes || savedRecipes.length === 0) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-4 animate-fade-in">
        <div className="rounded-2xl p-8 text-center" style={{ backgroundColor: "#FFFFFF", border: "1px solid #E5E0D8" }}>
          <BookHeart size={32} className="mx-auto mb-3" style={{ color: "#C4A882" }} strokeWidth={1.5} />
          <p className="font-serif text-base mb-1" style={{ color: "#2D3436" }}>Your RasaBox is empty</p>
          <p className="text-sm" style={{ color: "#9AA5B1", fontFamily: "Manrope, sans-serif" }}>
            Generate a recipe and tap the heart icon to save it here.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-6 py-4 animate-fade-in" data-testid="my-rasabox-panel">
      <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: "#FFFFFF", border: "1px solid #E5E0D8" }}>
        <div className="px-6 py-4 flex items-center justify-between"
          style={{ borderBottom: "1px solid #E5E0D8", backgroundColor: "#FDFBF7" }}>
          <div className="flex items-center gap-2">
            <BookHeart size={16} style={{ color: "#E07A5F" }} strokeWidth={1.5} />
            <h3 className="font-serif font-semibold text-base" style={{ color: "#2D3436" }}>My RasaBox</h3>
            <span className="text-xs px-2 py-0.5 rounded-full font-semibold"
              style={{ backgroundColor: "#E07A5F1A", color: "#E07A5F" }}>
              {savedRecipes.length}
            </span>
          </div>
          <p className="text-xs" style={{ color: "#9AA5B1", fontFamily: "Manrope, sans-serif" }}>
            Click a recipe to view it
          </p>
        </div>

        <div>
          {savedRecipes.map((saved, i) => (
            <div key={saved.id} data-testid={`saved-recipe-${i}`}
              className="flex items-center gap-3 px-6 py-4 transition-colors hover:bg-muted group"
              style={{ borderBottom: i < savedRecipes.length - 1 ? "1px solid #F4F1EA" : "none" }}>

              {/* Leaf icon */}
              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "#F2CC8F33" }}>
                <Leaf size={14} style={{ color: "#B8860B" }} strokeWidth={1.5} />
              </div>

              {/* Recipe info */}
              <button className="flex-1 text-left min-w-0" onClick={() => onSelect(saved.recipe)}>
                <p className="font-semibold text-sm truncate" style={{ color: "#2D3436", fontFamily: "Manrope, sans-serif" }}>
                  {saved.recipe.recipe_name}
                </p>
                <div className="flex items-center gap-3 mt-0.5 flex-wrap">
                  <span className="text-xs truncate" style={{ color: "#9AA5B1", fontFamily: "Manrope, sans-serif" }}>
                    {saved.recipe.input_ingredients?.slice(0, 4).join(", ")}
                    {saved.recipe.input_ingredients?.length > 4 ? "..." : ""}
                  </span>
                </div>
              </button>

              {/* Meta */}
              <div className="hidden sm:flex items-center gap-3 text-xs flex-shrink-0" style={{ color: "#9AA5B1" }}>
                {saved.recipe.input_dish_type && (
                  <span className="px-2 py-0.5 rounded-full text-xs"
                    style={{ backgroundColor: "#F4F1EA", color: "#5D6D7E", fontFamily: "Manrope, sans-serif" }}>
                    {saved.recipe.input_dish_type}
                  </span>
                )}
                <span className="flex items-center gap-1">
                  <Users size={10} /> {saved.recipe.servings}
                </span>
                <span className="flex items-center gap-1">
                  <Clock size={10} /> {saved.recipe.cook_time}
                </span>
              </div>

              {/* Remove button */}
              <button data-testid={`unsave-btn-${i}`}
                onClick={() => onUnsave(saved.recipe_id, saved.recipe)}
                className="p-2 rounded-full transition-all hover:scale-110 opacity-0 group-hover:opacity-100 flex-shrink-0"
                style={{ backgroundColor: "#FFF8F6", color: "#C0392B" }}
                title="Remove from RasaBox">
                <X size={13} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
